module.exports = __webpack_public_path__ + "img/master-image.ca5d33f0.png";